import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38390482"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-circle" }, null, -1))
const _hoisted_3 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "d-flex align-items-center rounded-pill border border-dark px-2 my-0"
  }, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1),
    _createElementVNode("button", {
      type: "button",
      class: "ms-2 btn-close",
      "aria-label": "Close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeSelected && _ctx.removeSelected(...args)))
    })
  ], 8, _hoisted_1))
}